import { mapGetters } from 'vuex';
import { LUXON_DATE_FORMAT_LONG } from '@/constants/dateTimeFormats';
import { formatDateTimeFromSQL } from '@/helpers/timeFormaterHelper';
import {LUDUM_SUBSCRIPTION_PLANS} from "../constants";
import {formatTime} from "../helpers/timeFormaterHelper";
const { ROWING_AUSTRALIA, BRITISH_ROWING, TELEMETRY_UNLIMITED, GOLD, GOLD_UNLIMITED, GOLD_WITH_RECORDING_CONTROLS, SILVER, SILVER_UNLIMITED, PLATINUM, PLATINUM_UNLIMITED, BRONZE_UNLIMITED, BRONZE } = LUDUM_SUBSCRIPTION_PLANS;

export default {
    destroyed() {
        // avoid memory leaks https://vuejs.org/v2/cookbook/avoiding-memory-leaks.html#Introduction
        if (this.$data) {
            Object.keys(this.$data).forEach(key => {
                this.$data[key] = null;
                this.$delete(this.$data, key);
            });
        }
    },

    methods: {
        squadGroupTranslation(count = 1) {
            return this.isClubDefaultSportWater ? this.$tc('squad', count) : this.$tc('group', count);
        },

        $globalMixin_pieceEffortTranslation(count = 1) {
            return this.isClubDefaultSportPaddling ? this.$tc('effort', count) : this.$tc('piece', count);
        },

        /**
         * Custom name of a piece when it has one, otherwise the default "Piece <number>" label
         */
        $globalMixin_pieceDisplayName(piece, pieceNumber) {
            const name = ((piece && piece.name) || '').trim();
            return name || `${this.$globalMixin_pieceEffortTranslation(1)} ${pieceNumber}`;
        },

        $globalMixin_goBack() {
            this.$router.go(-1);
        },

        $globalMixin_openLink(location, openInNewTab) {
            if (openInNewTab) {
                const routeUrl = this.$router.resolve(location);
                window.open(routeUrl.href, '_blank');
            } else {
                this.$router.push(location).catch(() => {});
            }
        },

        notAttendingGroupTranslation() {
            return this.selectedClub && this.selectedClub.club.data.subscription_info.data.subscription_plan.data.id == ROWING_AUSTRALIA ? this.$tc('missed') : this.$t('notAttending');
        },

        didAlternativeGroupTranslation() {
            return this.selectedClub && this.selectedClub.club.data.subscription_info.data.subscription_plan.data.id == ROWING_AUSTRALIA ? this.$tc('modified') : this.$t('didAlternative');
        },

        markAllAsNotAttendingGroupTranslation() {
            return this.selectedClub && this.selectedClub.club.data.subscription_info.data.subscription_plan.data.id == ROWING_AUSTRALIA ? this.$tc('markAllAsMissed') : this.$t('markAllAsNotAttending');
        },

        areYouSureToMarkAllAsNotAttendingGroupTranslation() {
            return this.selectedClub && this.selectedClub.club.data.subscription_info.data.subscription_plan.data.id == ROWING_AUSTRALIA ? this.$tc('areYouSureToMarkAllAsMissed') : this.$t('areYouSureToMarkAllAsNotAttending');
        },

        markAllAsDidAlternativeGroupTranslation() {
            return this.selectedClub && this.selectedClub.club.data.subscription_info.data.subscription_plan.data.id == ROWING_AUSTRALIA ? this.$tc('markAllAsModified') : this.$t('markAllAsDidAlternative');
        },

        unmarkAllAsDidAlternativeGroupTranslation() {
            return this.selectedClub && this.selectedClub.club.data.subscription_info.data.subscription_plan.data.id == ROWING_AUSTRALIA ? this.$tc('unmarkAllAsModified') : this.$t(' unmarkAllAsDidAlternative');
        },

        areYouSureToMarkAllAsDidAlternativeGroupTranslation() {
            return this.selectedClub && this.selectedClub.club.data.subscription_info.data.subscription_plan.data.id == ROWING_AUSTRALIA ? this.$tc('areYouSureToMarkAllAsModified') : this.$t('areYouSureToMarkAllAsDidAlternative');
        },

        areYouSureToUnmarkAllDidAlternativeGroupTranslation() {
            return this.selectedClub && this.selectedClub.club.data.subscription_info.data.subscription_plan.data.id == ROWING_AUSTRALIA ? this.$tc('areYouSureToUnmarkAllAsModified') : this.$t('areYouSureToUnmarkAllDidAlternative');
        },

        didNotAttendGroupTranslation() {
            return this.selectedClub && this.selectedClub.club.data.subscription_info.data.subscription_plan.data.id == ROWING_AUSTRALIA ? this.$tc('missed') : this.$t('didNotAttend');
        },

        defaultTrainingLoadMetric() {
            return this.selectedClub && this.selectedClub.club.data.subscription_info.data.subscription_plan.data.id == ROWING_AUSTRALIA && this.isClubDefaultSportPaddling ? 'foster' : 'ets';
        },

        noZoneTitle() {
            return this.selectedClub && this.selectedClub.club.data.subscription_info.data.subscription_plan.data.id == ROWING_AUSTRALIA ? this.$tc('tech') : this.$t('noZone');
        },

        isBritishRowingPlan() {
            return this.selectedClub && this.selectedClub.club.data.subscription_info.data.subscription_plan.data.id == BRITISH_ROWING;
        },

        isTelemetryPlan() {
            return this.selectedClub && this.selectedClub.club.data.subscription_info.data.subscription_plan.data.id == TELEMETRY_UNLIMITED;
        },

        isRowingAustraliaPlan() {
            return this.selectedClub && this.selectedClub.club.data.subscription_info.data.subscription_plan.data.id == ROWING_AUSTRALIA;
        },

        isSilverPlan() {
            return this.selectedClub && [SILVER, SILVER_UNLIMITED].includes(this.selectedClub.club.data.subscription_info.data.subscription_plan.data.id);
        },

        isGoldPlan() {
            return this.selectedClub && [GOLD, GOLD_UNLIMITED, GOLD_WITH_RECORDING_CONTROLS].includes(this.selectedClub.club.data.subscription_info.data.subscription_plan.data.id);
        },

       isPlatinumPlan() {
           return this.selectedClub && [PLATINUM, PLATINUM_UNLIMITED].includes(this.selectedClub.club.data.subscription_info.data.subscription_plan.data.id);
       },

       isBronzePlan() {
           return this.selectedClub && [BRONZE_UNLIMITED, BRONZE].includes(this.selectedClub.club.data.subscription_info.data.subscription_plan.data.id);
       },
    },

    computed: {
        ...mapGetters(['isClubDefaultSportPaddling', 'isClubDefaultSportWater', 'selectedClub'])
    },

    filters: {
        $filter_formatDateTime(value, format = LUXON_DATE_FORMAT_LONG, emptyValue = '-') {
            return !value ? emptyValue : formatDateTimeFromSQL(value, format);
        },

        $filter_formatTime(value, format, emptyValue, decimals) {
            return !value ? emptyValue : formatTime(value, format, emptyValue, decimals);
        },

        $filter_formatNumber(value, decimals) {
            value = parseFloat(value);
            if (!isNaN(value)) {
                return value.toFixed(decimals).replace(/\d(?=(\d{3})+(?!\d))/g, '$&,');
            } else {
                value = 0.00000000;
                return value.toFixed(decimals).replace(/\d(?=(\d{3})+(?!\d))/g, '$&,');
            }
        },

        $filter_formatSpeedAsPace(value) {
            if (value) {
                return formatTime(500 / value);
            } else {
                return '-';
            }
        },

        $filter_formatSpeedAsGMT(value, gmtScore) {
            if (value && gmtScore) {
                return parseFloat(value * 100 / (2000 / gmtScore)).toFixed(1);
            } else {
                return '-';
            }
        },

        $filter_formatTimeFromMiliseconds(value, format, emptyValue, decimals) {
            return !value ? emptyValue : formatTime(value / 1000, format, emptyValue, decimals);
        },
    }
};
